module.exports = __webpack_public_path__ + "img/s5Logo.b23859a4.png";